export default "/images/vendor/flag-icon-css/flags/4x3/pk.svg?d93be02c73adbb0250bc458f7e745d4b";